export const createslowmovingproducts =`
mutation CreateSlowMovingProduct($input: CreateSlowMovingProductInput!) {
  createSlowMovingProduct(input: $input) {
    success
    error
    message
  }
}



`;
export const updateslowmovingproducts =`

mutation UpdateSlowMovingProduct($input: UpdateSlowMovingProductInput!) {
  updateSlowMovingProduct(input: $input) {
    success
    error
    message
  }
}


`
export const deleteslowmovingproducts = `
mutation DeleteSlowMovingProduct($id: ID!) {
  deleteSlowMovingProduct(id: $id) {
    success
    error
    message
  }
}

`

export const excelexport =`
mutation ExportSlowMovingProductReport(
  $startDate: Date,
  $endDate: Date,
  $productCategories: [String],
  $brands: [String],
  $productNames: [String],
  $agentNames: [String],
  $userIds: [Int],
  $agesOfStock: [String]
) {
  exportSlowMovingProductReport(
    startDate: $startDate,
    endDate: $endDate,
    productCategories: $productCategories,
    brands: $brands,
    productNames: $productNames,
    agentNames: $agentNames,
    userIds: $userIds,
    agesOfStock: $agesOfStock
  ) {
    success
    message
    fileUrl
  }
}


`